exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-title[data-v-f1eb7646]{width:100%;text-align:center\n}\n", ""]);

// exports
